import tokenManager from './token'
import { login, loginWithToken } from '../api'

/**
 * 用户认证管理类
 */
class AuthManager {
  constructor() {
    this.isAuthenticated = false
    this.user = null
  }

  /**
   * 用户登录
   * @param {Object} credentials - 登录凭据
   * @param {string} credentials.username - 用户名
   * @param {string} credentials.password - 密码
   * @returns {Promise<Object>} 登录结果
   */
  async login(credentials) {
    try {
      const response = await login(credentials)
      
      if (response && response.token) {
        // 保存token和refresh token
        const token = response.token.startsWith('Bearer') || response.token.startsWith('Token') 
          ? response.token 
          : `Bearer ${response.token}`

          console.log('response:', response)
        
        tokenManager.setToken(token, response.refreshToken)
        this.isAuthenticated = true
        this.user = response.user || null
        
        console.log('Login successful')
        return { success: true, user: this.user }
      } else {
        console.error('Login failed: no token in response')
        return { success: false, error: 'No token received' }
      }
    } catch (error) {
      console.error('Login error:', error)
      return { success: false, error: error.message || 'Login failed' }
    }
  }



  /**
   * 用户登出
   */
  logout() {
    console.log('Logging out user')
    tokenManager.clearToken()
    this.isAuthenticated = false
    this.user = null
  }


  /**
   * 获取当前用户信息
   * @returns {Object|null}
   */
  getCurrentUser() {
    return this.user
  }

  /**
   * 设置用户信息
   * @param {Object} user - 用户信息
   */
  setCurrentUser(user) {
    this.user = user
  }

  /**
   * 初始化认证状态（应用启动时调用）
   * @returns {Promise<boolean>}
   */
  async initializeAuth() {
    try {
      const token = tokenManager.getToken()
      if (token) {
        return true;
      }
      return false
    } catch (error) {
      console.error('Auth initialization error:', error)
      this.logout()
      return false
    }
  }
}

export const authManager = new AuthManager()
export default authManager 